import React from 'react'
import Layout from '../containers/Layout';
import { recordEvent } from '../components/Analytics';
import { useLocation } from '../components/Router';
import SiteHead from '../containers/SiteHead';
import notFoundImage from '../img/404.svg';

import '../sass/404.scss';

const NotFound = () => {
  const { pathname } = useLocation();
  const buildVersion = null;

  recordEvent({ name: "404", path: pathname, buildVersion });

  return (
    <>
      <SiteHead
        title={"EarningsCall · Not Found"}
        description={"Oops, we can't find that page."}
      />
      <section className="error-section">
        <div className="container">
          <div className="img-container">
            <img src={notFoundImage} alt="Page Not Found" />
          </div>
        </div>
      </section>
    </>
  );
};

const NotFoundExport = (props) => (
  <Layout {...props}>
    <NotFound {...props}/>
  </Layout>
);

export default NotFoundExport;
